<template>
  <v-container fluid full-height grid-list-md>
    <v-layout row wrap>
      <v-flex xs6>
        <div class="text-xs-left">
          <v-breadcrumbs :items="breadcrumbs" divider=">"></v-breadcrumbs>
        </div>
      </v-flex>
      <v-flex xs6>
        <div style="display: flex; justify-content: flex-end;">
          <v-menu offset-y>
            <template v-slot:activator="{on,attrs}">
              <v-btn
              color="primary"
              v-bind="attrs"
              v-on="on"
              >
                <v-icon>add_circle</v-icon>Add
              </v-btn>
            </template>
            <v-list>
              <v-list-tile @click="onRegister">
                <v-list-tile-content>
                  <v-list-tile-title>ADD NEW</v-list-tile-title>
                </v-list-tile-content>
              </v-list-tile>
            </v-list>
          </v-menu>

          <v-btn @click="showFilters = !showFilters" color="#FF4545">
            <v-icon>filter_list</v-icon>Filter
            <v-icon>{{ showFilters ? 'arrow_drop_up' : 'arrow_drop_down' }}</v-icon>
          </v-btn>
        </div>
      </v-flex>
      <v-flex xs12 v-if="showFilters">
        <v-card>
          <v-layout row wrap class="pa-3">
            <v-flex sm3>
              <v-text-field
                name="code"
                label="Production Item Code"
                type="text"
                v-model="queryParams.code"
              ></v-text-field>
            </v-flex>
            <v-flex sm3>
              <v-text-field
                name="name"
                label="Production Item Name"
                type="text"
                v-model="queryParams.name"
              ></v-text-field>
            </v-flex>
            <v-flex sm3>
              <v-select
                :items="statusList"
                label="Status"
                v-model="queryParams.status"
                item-text="label"
                item-value="value"
              ></v-select>
            </v-flex>
            <v-flex sm3>
              <v-btn outline color="primary" @click="onSearch">
                Search
                <v-icon right>search</v-icon>
              </v-btn>
            </v-flex>
          </v-layout>
        </v-card>
      </v-flex>
      <v-flex xs12 class="mt-1">
        <v-card>
          <v-data-table
            :headers="headers"
            :items="productionItemList"
            class="elevation-1"
            :loading="showListLoading"
            :total-items="totalRows"
            :rows-per-page-items="rowsPerPageItems"
            :pagination.sync="pagination"
            must-sort
          >
          <template slot="items" slot-scope="props">
              <td>
                <v-btn
                  flat
                  icon
                  color="blue lighten-2"
                  @click="onEdit(props.item)"
                >
                  <v-icon>edit</v-icon>
                </v-btn>
              </td>
              <td>
                <v-icon
                  v-if="props.item.status == 'ACTIVE'"
                  medium
                  color="green"
                  >check_circle</v-icon
                  >
                <v-icon v-else medium color="red">cancel</v-icon>
              </td>
              <td>{{ props.item.code }}</td>
              <td>{{ props.item.name }}</td>
              <td>{{ props.item.description }}</td>
              <td>
                {{
                  props.item.updatedDateInMilliSeconds
                    | format-ms-date-time
                }}
              </td>
              <td>{{ props.item.updatedBy }}</td>
            </template>
          </v-data-table>
        </v-card>
      </v-flex>
    </v-layout>
  </v-container>
</template>

<script>
import { productionItemService } from "../../services/production-item-service";

export default {
  name: "ProductionItemList",
  data: () => ({
    showListLoading: false,
    showFilters: false,
    breadcrumbs: [
      {
        text: "Manufacturing Management",
        disabled: true,
      },
      {
        text: "Production Item",
        disabled: true,
      },
    ],
    statusList: [
      { label: "--- ALL ---", value: "" },
      { label: "ACTIVE", value: "ACTIVE" },
      { label: "INACTIVE", value: "INACTIVE" },
    ],
    headers: [
      { text: "Action", sortable: false },
      { text: "Status", value: "status", sortable: false },
      { text: "Code", align: "left", value: "code" },
      { text: "Name", align: "left", value: "name" },
      { text: "Description", value: "description" },
      { text: "Updated Date", value: "updatedDate" },
      { text: "Updated By", value: "updatedBy" },
    ],
    pagination: {
      descending: true,
      page: 1,
      rowsPerPage: 50,
      sortBy: "updatedDate",
      totalItems: 0,
    },
    queryParams: {
      name: "",
      code: "",
      status: "ACTIVE",
      isAddDetails: false,
    },
    totalRows: 0,
    rowsPerPageItems: [25, 50, 100],
    productionItemList: [],
  }),
  watch: {
    pagination: {
      handler() {
        this.getProductionItemList();
      },
      deep: true,
    },
  },
  created() {
    //for deep linking
    if (this.$route.query.name) {
      this.queryParams.name = this.$route.query.name;
    }
    if (this.$route.query.code) {
      this.queryParams.code = this.$route.query.code;
    }
    if (this.$route.query.status) {
      this.queryParams.status = this.$route.query.status;
    }
    if (this.$route.query.isAddDetails) {
      this.queryParams.isAddDetails = this.$route.query.isAddDetails;
    }
    if (this.$route.query.page) {
      this.pagination.page = this.$route.query.page;
    }
    if (this.$route.query.size) {
      this.pagination.size = this.$route.query.size;
    }
  },
  methods: {
    onSearch() {
      this.queryParams.page = this.pagination.page;
      this.queryParams.size = this.pagination.rowsPerPage;
      this.$router.replace({
        name: "production-items",
        query: this.queryParams,
      });
      this.getProductionItemList();
    },
    getProductionItemList() {
      this.showListLoading = true;
      let order = this.pagination.descending ? "desc" : "asc";
      productionItemService
        .getProductionItemList(
          this.queryParams,
          this.pagination.page,
          this.pagination.rowsPerPage,
          this.pagination.sortBy + "," + order
        )
        .then((res) => {
          if (res.data) {
            this.productionItemList = res.data.productionItemList;
            this.totalRows = res.data.totalElements;
          }
        })
        .catch((err) => {
          console.log(err);
        })
        .finally(() => {
          this.showListLoading = false;
        });
    },
    onRegister() {
      this.$router.push("/production-item/new");
    },
    onEdit(productionItem) {
      // go to details page
      this.$router.push("/production-item/" + productionItem.id);
    },
  },
};
</script>
